module.exports = __webpack_public_path__ + "static/media/Logo.478df9fb.png";